
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AnalysisResponseDto } from '../dtos/analysis.dto';
import { environment } from '../../environments/environment';
import {Globals} from '../global/globals';

@Injectable({ providedIn: 'root' })
export class AnalysisService {


  private readonly baseUri = this.globals.backendUri + '/analysis';

  constructor(private http: HttpClient, private globals: Globals) {}

  analyze(text: string): Observable<AnalysisResponseDto> {
    const body = { text };
    return this.http.post<AnalysisResponseDto>(this.baseUri, body);
  }
}
